import React from 'react';

export default function MailBoxesIntegration({
  isOutlook,
  setIsOutlook,
  isGmailAuthenticated,
  isOutlookAuthenticated,
}) {
  return (
    <div className="mx-auto  flex  w-fit   gap-1 text-sm">
      {isOutlookAuthenticated && (
        <button
          title="Outlook"
          className={`br-1 rounded-t-xl  border border-zinc-700 px-2 text-white transition-all duration-200  hover:bg-zinc-700 md:px-3 
                  ${isOutlook ? 'bg-zinc-100' : 'bg-zinc-800'}`}
          onClick={() => setIsOutlook(true)}
        >
          <img
            src="/assets/icons8-microsoft-outlook.svg"
            alt="Outlook"
            className="h-5 w-5 md:h-6 md:w-6"
          />
        </button>
      )}

      {/* Gmail Button */}
      {isGmailAuthenticated && (
        <button
          title="Gmail"
          className={`br-1 rounded-t-xl  border border-zinc-700 px-2 text-white transition-all duration-200  hover:bg-zinc-700 md:px-3 
                  ${!isOutlook ? 'bg-zinc-100' : 'bg-zinc-800'}`}
          onClick={() => setIsOutlook(false)}
        >
          <img
            src="/assets/icons8-gmail.svg"
            alt="Gmail"
            className="h-5 w-5 md:h-6 md:w-6"
          />
        </button>
      )}
    </div>
  );
}
